module.exports = __webpack_public_path__ + "img/activity-monitor-trial-expired.a7af32fa.png";